import React, { useMemo } from 'react';
import { Button } from 'antd';
import { CusSelect } from './styled';
import { EQUAL_ONLY_METADATA } from '@components/mapping-panel/constants/constant';
import styles from '@src/emp-3.0/components/MappedEventBuilder/MappingRulesBuilder/index.less';
import DeleteSvg from '@icons/mapping-panel/delete-icon.svg';
import { getOperatorOptions, isOnlyStars } from '@src/emp-3.0/utils';
import { EStringOp } from '@src/emp-3.0/types';
import { buildOptionsWithTag } from '@src/components/common/AutoCompleteInput/buildOptionsWithTag';
import { WarningIcon } from '@src/components/common/AutoCompleteInput/WarningIcon';
import { AutoComplete as AutoCompleteStyled } from '../styled';
import { ERenamedDimension } from '@src/common/constant/enum';
import { MATCH_PATTERN_ERROR_MESSAGE } from '@src/emp-3.0/constants/common';
const RuleItem: React.FC<any> = ({
  index,
  data,
  disabled,
  disableDelete,
  onChange,
  onDelete,
  metadataName,
  options,
  loading,
  isNoRules,
  errorFields = [],
}) => {
  const { operatorOptionsExcludingNull: operatorOptions } = getOperatorOptions();
  let operators = operatorOptions;
  if (EQUAL_ONLY_METADATA.includes(data?.key)) {
    operators = operatorOptions?.filter(
      (op) => op.value === EStringOp.EQ || op.value === EStringOp.NOT_EQ,
    );
  }
  if (
    [ERenamedDimension.edited_screen_title, ERenamedDimension.edited_page_title].includes(data?.key)
  ) {
    operators = operatorOptions?.filter(
      (op) =>
        op.value === EStringOp.EQ ||
        op.value === EStringOp.NOT_EQ ||
        op.value === EStringOp.CONTAINS ||
        op.value === EStringOp.NOT_CONTAINS,
    );
  }

  const metadataRuleValue = data?.value?.[0];
  const metadataRuleOptions = buildOptionsWithTag(options || [], data?.key, metadataRuleValue);
  const isEmptyValue = !metadataRuleValue || metadataRuleValue === '' || isNoRules;

  const isValueError = errorFields?.includes('metadata_key_value') && isEmptyValue;
  const isInvalidValue =
    data.op === EStringOp.MATCH_PATTERN &&
    errorFields.includes('match_pattern_error') &&
    isOnlyStars(metadataRuleValue);

  const autoCompleteInputStatus = isValueError || isInvalidValue ? 'error' : undefined;

  const suffix = useMemo(() => {
    if (autoCompleteInputStatus === 'error') {
      return (
        <WarningIcon
          title={
            isInvalidValue
              ? MATCH_PATTERN_ERROR_MESSAGE
              : 'The metadata all rule cannot be all null.'
          }
          iconStyle={{ color: '#ff4d4f' }}
        />
      );
    }
    return <span />;
  }, [autoCompleteInputStatus, isInvalidValue, isValueError]);

  return (
    <div className={styles.ruleRow}>
      <span className={styles.orWidth}>
        {index > 0 && <span className={styles.orTag}>OR</span>}
      </span>
      <div style={{ minWidth: '90px', flexShrink: 1, flexGrow: 0 }}>
        {metadataName || ' Metadata Name'}
      </div>
      <CusSelect
        disabled={disabled}
        style={{ margin: '8px', width: 'fit-content', height: '28px', minWidth: '80px' }}
        dropdownMatchSelectWidth={120}
        options={operators}
        value={data.op}
        onChange={(value) => {
          data.op = value;
          onChange(data);
        }}
      />
      <AutoCompleteStyled
        disabled={disabled}
        loading={loading}
        options={metadataRuleOptions}
        style={{ display: 'flex', flex: '1' }}
        value={metadataRuleValue}
        onChange={(value) => {
          data.value = [value];
          onChange?.(data);
        }}
        status={autoCompleteInputStatus}
        suffix={suffix}
      />
      {!disabled && (
        <span className={styles.deleteIcon}>
          {!disableDelete && <Button type="text" icon={<DeleteSvg />} onClick={() => onDelete()} />}
        </span>
      )}
    </div>
  );
};

export default RuleItem;
